import React from 'react';
import {useNavigate} from 'react-router-dom';
import styles from './BackButton.module.scss';

interface BackButtonProps {
    className?: string;
    onClick?: () => void;
    to?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({
                                                          className = '',
                                                          onClick,
                                                          to
                                                      }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else if (to) {
            navigate(to);
        } else {
            navigate(-1);
        }
    };

    return (
        <button
            className={`${styles.backButton} ${className}`}
            onClick={handleClick}
        >
            ← Назад
        </button>
    );
};